module.exports = __webpack_public_path__ + "img/pro_ten_4.383226c9.jpg";